import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getHomePath } from '../../utils/permissions';
import LoadingSpinner from '../LoadingSpinner';

/**
 * RootRedirect - Smart redirect component for the root path
 * Redirects based on authentication state and user tier
 */
export const RootRedirect = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated && user) {
    // Redirect to appropriate dashboard based on tier
    const homePath = getHomePath(user);
    return <Navigate to={homePath} replace />;
  }

  // Not authenticated - redirect to tenant login
  return <Navigate to="/login" replace />;
};

export default RootRedirect;
